import { tagsCommonConfig } from './common'
import type { TagsPageConfig } from './types'
import { theme as brandTheme } from '@/config/brands'

/**
 * Flipnovel 品牌标签页面配置
 */
export const tagsConfig = {
  ...tagsCommonConfig,
  theme: {
    popupTagBgColor: '#262E3A',
    popupTagColor: brandTheme.textSecondary,
    filterBgColor: '#262E3A',
    filterActiveBgColor: brandTheme.primaryColor,
    filterColor: brandTheme.textSecondary,
    filterActiveColor: brandTheme.textInverse,
  },
} satisfies TagsPageConfig
